import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'env/environment';
import { clone } from 'lodash-es';

@Injectable()
export class ExcludeHeaderRequestInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Likely this can be replaced by AuthenticationService.skipRequest by
    // examining the request url if starts with MCE base
    if (request.url.startsWith(environment.mceBase) || request.url.includes('cloudflare')) {
      const clonedRequest = request.clone({ headers: request.headers.delete('Authorization') });
      return next.handle(clonedRequest);
    } else {
      return next.handle(request);
    }
  }
}
